const routes = {
  signUp: "/api/user/signup",
  logIn: "/api/user/login",
  forgotPassword: "/api/user/reset-password",
  changePassword: "/api/user/change-password",
  getBlogs: "/api/blog",
  getPrograms: "/api/program",
  getUser: "/api/user/",
  updateUser: "/api/user",
  getFblogs: "/api/blog/featured",
  getHome: "/api/home",
  getReviews: "/api/review",
  getAdminReviews: "/api/review/admin",
  deleteReview: (id) => `/api/review/${id}`,
  postReview: "/api/user/review/program",
  reviewApprove: "/api/review/approve",
  addToWishlist: "/api/user/addToWishlist",
  removeFromWishlist: "/api/user/deleteFromWishlist",
  googleLogin: "/api/user/google",
  specialRequest: "/api/user/specialrequest",
  newsLetter: "/api/user/newsletter",
  deleteSpecialRequest: (id) => `/api/user/specialrequest/${id}`,
  deleteNewsletter: (id) => `/api/user/newsletter/${id}`,
  // admin
  getAdminPrograms: "/api/program/admin",
  reorderPrograms: "/api/program/admin/reorder",
  createProgram: "/api/program",
  getAdminStastics: "/api/user/adminStats",
  uploadImage: "/api/uploadImg",
  counterEdit: "/api/home/editCounts",
  getUserBookLink: "/api/user/bookProgram",
  getAllUsers: "/api/user/get-all",
  deleteUser: (id) => `/api/user/${id}`,
  addReview: "/api/review/add",
  getAllCareers: "/api/careers",
  careersAdminList: "/api/careers/admin",
  careersAdminItem: "/api/careers/:id",
  addCareer: "/api/careers/admin/create",
  editCareer: "/api/careers/admin/edit",
  duplicateCareer: "/api/careers/admin/duplicate",
  reorderCareers: "/api/careers/admin/reorder",
  blogs: "/api/blog",
  getAllEvents: "/api/events",
  getSingleEvent: (id) => `/api/events/${id}`,

  getAdminBlogs: "/api/blog/admin",

  capacityPublicList: "/api/capacity/projects",
  capacitySettings: "/api//capacity/settings",

  // Capacity (Admin)
  capacityAdminList: "/api/capacity/admin/projects",
  capacityAdminReorder: "/api/capacity/admin/projects/reorder",
  capacityPublicItem: (id) => `/api/capacity/projects/${id}`,
  capacityAdminItem: (id) => `/api/capacity/admin/projects/${id}`,
  capacityAdminPublish: (id) => `/api/capacity/admin/projects/${id}/publish`,

  capacityAdminPartnerAdd: (projectId) =>
    `/api/capacity/admin/projects/${projectId}/partners`,
  capacityAdminPartnerDelete: (projectId, partnerId) =>
    `/api/capacity/admin/projects/${projectId}/partners/${partnerId}`,

  capacityAdminNewsList: (projectId) =>
    `/api/capacity/admin/projects/${projectId}/news`,
  capacityAdminNewsAdd: (projectId) =>
    `/api/capacity/admin/projects/${projectId}/news`,
  capacityAdminNewsItem: (newsId) => `/api/capacity/admin/news/${newsId}`,
  capacityAdminNewsPublish: (newsId) =>
    `/api/capacity/admin/news/${newsId}/publish`,
  capacityAdminNewsReorder: `/api/capacity/admin/news/reorder`,
  capacityNewsSingle: (idOrSlug) => `/api/capacity/news/${idOrSlug}`,
  capacityProjectNewsSingle: (projectIdOrSlug, newsIdOrSlug) =>
    `/api/capacity/projects/${projectIdOrSlug}/news/${newsIdOrSlug}`,

  /* ================
   * Events (Admin)
   * ================ */
  eventsAdminList: `/api/events/admin`,
  eventsAdminItem: (id) => `/api/events/admin/${id}`, // لو مش عاملين /admin/:id استخدم /events/:id
  createEvent: `/api/events`,
  updateEvent: (id) => `/api/events/${id}`,
  deleteEvent: (id) => `/api/events/${id}`,
  duplicateEvent: (id) => `/api/events/${id}/duplicate`,
  publishEvent: (id) => `/api/events/${id}/publish`,
  reorderEvent: `/api/events/reorder`,

  /* ================
   * Events (Public)
   * ================ */
  eventsPublicList: `/api/events`,
  eventsPublicItem: (id) => `/api/events/${id}`,

  blogRecordView: (id) => `/api/blog/${id}/view`,

  updateProgramStatus: (id) => `/api/program/${id}/status`,

  // Team Departments
  teamDeptAdminList: "/api/team-departments",
  teamDeptAdminCreate: "/api/team-departments",
  teamDeptAdminUpdate: (id) => `/api/team-departments/${id}`,
  teamDeptAdminDelete: (id) => `/api/team-departments/${id}`,
  teamDeptAdminReorder: "/api/team-departments/reorder",
  teamDeptPublicList: "/public/team/departments",

  // Team Members (existing from previous message)
  teamAdminList: "/api/team",
  teamAdminCreate: "/api/team",
  teamAdminItem: (id) => `/api/team/${id}`,
  teamAdminUpdate: (id) => `/api/team/${id}`,
  teamAdminDelete: (id) => `/api/team/${id}`,
  teamAdminReorder: "/api/team/reorder",
};
export default routes;
